function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useUniqueID } from "@xo-union/react-unique-id";
import SignUpForm from "../SignUpForm/index.js";
import LogInForm from "../LogInForm/index.js";
import CanSpam from "../CanSpam/index.js";
var LOG_IN = 'LOG_IN';
var SIGN_UP = 'SIGN_UP';
var MembershipForm = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var formType = _ref.formType,
    inProgress = _ref.inProgress,
    initialFocusRef = _ref.initialFocusRef,
    metadata = _ref.metadata,
    onClickLogIn = _ref.onClickLogIn,
    onClickSignUp = _ref.onClickSignUp,
    onLogIn = _ref.onLogIn,
    onSignUp = _ref.onSignUp,
    givenEmailProps = _ref.emailProps,
    givenPasswordProps = _ref.passwordProps,
    givenAlertProps = _ref.alertProps,
    SignUpView = _ref.SignUpView,
    LogInView = _ref.LogInView,
    logInFormProps = _ref.logInFormProps,
    signUpFormProps = _ref.signUpFormProps,
    alertIDProp = _ref.alertID,
    children = _ref.children;
  var alertIDOverride = givenAlertProps.id || alertIDProp;
  var alertID = useUniqueID(alertIDOverride);
  var staticAlertProps = _objectSpread(_objectSpread({}, givenAlertProps), {}, {
    id: alertID
  });
  var _React$useState = React.useState({
      type: 'error',
      visible: false
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    alertProps = _React$useState2[0],
    setAlertProps = _React$useState2[1];
  var describedById = alertProps.visible ? alertID : null;
  var fieldProps = {
    'aria-describedby': describedById
  };
  var emailProps = _objectSpread(_objectSpread({}, fieldProps), givenEmailProps);
  var passwordProps = _objectSpread(_objectSpread({}, fieldProps), givenPasswordProps);
  var dismissError = function dismissError() {
    setAlertProps(function (curProps) {
      return _objectSpread(_objectSpread({}, curProps), {}, {
        visible: false
      });
    });
  };
  React.useImperativeHandle(ref, function () {
    return {
      showError: function showError(data) {
        setAlertProps(function (curProps) {
          return _objectSpread(_objectSpread({}, curProps), {}, {
            data: data,
            visible: true
          });
        });
      },
      dismissError: dismissError
    };
  }, []);
  React.useEffect(function () {
    return dismissError();
  }, [formType]);
  React.useEffect(function () {
    /* eslint-disable no-console */
    if (typeof alertIDProp !== 'undefined') {
      console.warn('MembershipForm: Please use `alertProps.id` instead of `alertID`');
    }
    if (typeof children !== 'undefined') {
      console.warn('MembershipForm: children prop is deprecated. Either stop using `alertWrapper` or stop passing `children` in favor of sibling elements.');
    }
  }, [alertIDProp, children]);
  return /*#__PURE__*/React.createElement(CanSpam, null, formType === SIGN_UP && /*#__PURE__*/React.createElement(SignUpView, _extends({
    onClickLogIn: onClickLogIn,
    onSubmit: onSignUp,
    metadata: metadata,
    inProgress: inProgress,
    initialFocusRef: initialFocusRef,
    emailProps: emailProps,
    passwordProps: passwordProps,
    alertProps: _objectSpread(_objectSpread({}, staticAlertProps), alertProps)
  }, signUpFormProps)), formType === LOG_IN && /*#__PURE__*/React.createElement(LogInView, _extends({
    onClickSignUp: onClickSignUp,
    onSubmit: onLogIn,
    metadata: metadata,
    inProgress: inProgress,
    initialFocusRef: initialFocusRef,
    emailProps: emailProps,
    passwordProps: passwordProps,
    alertProps: _objectSpread(_objectSpread({}, staticAlertProps), alertProps)
  }, logInFormProps)), children);
});
process.env.NODE_ENV !== "production" ? MembershipForm.propTypes = {
  /**
   * Name of form
   */
  formType: PropTypes.oneOf([SIGN_UP, LOG_IN]).isRequired,
  /**
   * Callback called when clicking on the Log In link
   */
  onClickLogIn: PropTypes.func.isRequired,
  /**
   * Callback called when clicking on the Sign Up link
   */
  onClickSignUp: PropTypes.func.isRequired,
  /**
   * Callback called when the Sign Up form is submitted
   */
  onSignUp: PropTypes.func.isRequired,
  /**
   * Callback called when the Log In form is submitted
   */
  onLogIn: PropTypes.func.isRequired,
  /**
   * Metadata about user action necessary for sign up form
   */
  metadata: PropTypes.shape({
    userAction: PropTypes.string.isRequired,
    applicationName: PropTypes.string.isRequired
  }).isRequired,
  /**
   * Whether or not we are waiting for a membership response. Used to render the "loading" state of
   * the form
   */
  inProgress: PropTypes.bool,
  /**
   * Component to use as sign up view. Will default to SignUpForm.
   */
  SignUpView: PropTypes.func,
  /**
   * Component to use as log in view. Will default to LogInForm.
   */
  LogInView: PropTypes.func,
  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape({})
  }),
  /**
   * Used to set additional props on the email field
   */
  emailProps: PropTypes.shape(),
  /**
   * Used to set additional props on the password field
   */
  passwordProps: PropTypes.shape(),
  /**
   * Used to set additional props on the alert
   */
  alertProps: PropTypes.shape(),
  /**
   * Props to pass to sign up form
   */
  signUpFormProps: PropTypes.shape(),
  /**
   * Props to pass to log in form
   */
  logInFormProps: PropTypes.shape(),
  /**
   * @deprecated
   *
   * Override the alert ID. Prefer using `alertProps.id`
   */
  alertID: PropTypes.string,
  /**
   * @deprecated
   *
   * This is leveraged by the `alertWrapper` HOC which is also deprecated.
   */
  children: PropTypes.node
} : void 0;
MembershipForm.defaultProps = {
  inProgress: false,
  SignUpView: SignUpForm,
  LogInView: LogInForm,
  emailProps: {},
  passwordProps: {},
  alertProps: {}
};
MembershipForm.displayName = 'MembershipForm';
export default MembershipForm;